import BustleLogoSrc from '@images/marketing/News_Bustle.png';
import EverygirlLogoSrc from '@images/marketing/News_Everygirl.png';
import MICLogoSrc from '@images/marketing/News_MIC.png';
import TwitterReviewedLogoSrc from '@images/marketing/News_TwitterReviewed.png';
export var newsSectionContent = {
    pressQuotes: [
        {
            imageData: { src: MICLogoSrc, alt: 'MIC Logo' },
            externalLink: 'https://www.inkl.com/news/this-plant-based-meat-is-the-surprising-favorite-of-nutritionists',
            quote: '“As a pet parent, it can be disheartening to look at the ingredient list of your dog’s food: It’s often filled with hard-to-pronounce mystery ingredients and cheap fillers. But if you’ve ever been curious about fresh pet food, Nom Nom is worth having on your radar.”',
        },
        {
            imageData: { src: EverygirlLogoSrc, alt: 'Everygirl Logo' },
            quote: '“If Otis liked food before, he certainly loves it now. I often find him back in the kitchen, the bowl previously licked clean, trying to lick it even cleaner because he loves the food so much.”',
        },
        {
            imageData: { src: BustleLogoSrc, alt: 'Bustle Logo' },
            quote: '“The subscription pet food brand has been winning over pet parents for its nutritious recipes, which are developed with the expertise of board-certified veterinary nutritionists and made with real meats, veggies, and vitamins — no fillers whatsoever.”',
        },
        {
            imageData: { src: TwitterReviewedLogoSrc, alt: 'Twitter Reviewed Logo' },
            externalLink: 'https://www.reviewed.com/pets/content/nom-nom-dog-food-review-should-you-switch',
            quote: '“Nom Nom is the Reviewed-approved fresh dog food delivery service that creates personalized meal plans for your favorite fur ball and delivers straight to your doorstep. Skip the grocery store and the recipe books and opt for easy, fresh dog food to treat your pup to the good stuff.”',
        },
    ],
};
